import Vue from 'vue'
import {
  Select,
  Input,
  Row,
  Col,
  Spin,
  message,
  Breadcrumb,
  Button,
  Modal,
  Tooltip
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Select)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Spin)
Vue.use(Breadcrumb)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Tooltip)

Vue.prototype.$message = message;
